import { Center, Text, Flex, Anchor, Loader } from '@mantine/core';
import { useBusiness, useUser } from '../../../hooks';
import classes from '../Admin.module.css';
import { GenericErrorBoundary } from '../../../shared/components/GenericErrorBoundary';
import { useTranslation } from 'react-i18next';
import { ShowAndCopyClientId } from './ShowAndCopyClientId';
import { ShowClientSecret } from './ShowClientSecret';
import { RotateSecret } from './RotateSecret';
import { CreateClientModal } from './CreateClientModal';
import { GenericErrorFallback } from '../../../shared/components/GenericErrorFallback';
import DevToolsCard from './DevToolsCard';
import { BetaIcon } from '../../../../lib/components';

export const ApiAccess = () => {
  const { t } = useTranslation();
  const { data: user, isError } = useUser();
  const { data: business, isLoading } = useBusiness(user?.businessId);
  const apiDocs =
    'https://docs.live-eo.com/tradeaware/user-guides/authentication';

  if (isLoading) {
    return (
      <Center w="100%" h="100vh">
        <Loader />
      </Center>
    );
  }

  if (isError || !business || !user) {
    return <GenericErrorFallback />;
  }

  const showCreateClientModal = !business?.machineToMachineClientId;

  return (
    <DevToolsCard title={t('devTools.apiAccess.title')}>
      <Text fs="italic">{t('devTools.apiAccess.description')}</Text>

      {showCreateClientModal ? (
        <CreateClientModal businessId={user?.businessId} />
      ) : (
        <>
          <GenericErrorBoundary title={t('developerTools.error')}>
            <ShowAndCopyClientId businessId={user?.businessId} />
            <ShowClientSecret clientId={business?.machineToMachineClientId} />
          </GenericErrorBoundary>
          <Flex justify="space-between" align="center">
            <Text fs="italic">
              {t('devTools.apiAccess.apiText')}{' '}
              <Anchor
                target="_blank"
                underline="hover"
                href={apiDocs}
                className={classes.link}
                rel="noopener"
              >
                {t('devTools.apiAccess.docsLink')}
              </Anchor>
            </Text>
            <Anchor
              target="_blank"
              underline="hover"
              href={apiDocs}
              c="white"
              className={classes.iconLink}
              rel="noopener"
            >
              <BetaIcon icon="external-link" />
            </Anchor>
          </Flex>
          <RotateSecret clientId={business?.machineToMachineClientId} />
        </>
      )}
    </DevToolsCard>
  );
};
